import type { MessageKey } from "./ru"

export const ptBRMessages = {
  "common.loading": "Carregando...",
  "common.error": "Erro",
  "common.back": "Voltar",
  "common.next": "Avançar",
  "common.search": "Pesquisar",
  "auth.loginErrorTitle": "Erro de login",
  "auth.openViaTelegram": "Abra o aplicativo pelo Telegram",
  "auth.telegramRequired": "O aplicativo deve ser aberto pelo Telegram",
  "auth.authorizationError": "Erro de autorização",
  "device.rotatePortrait": "Gire o dispositivo para a posição vertical",
  "country.brazil": "Brasil",
  "country.vietnam": "Vietnã",
  "country.egypt": "Egito",
  "country.india": "Índia",
  "country.indonesia": "Indonésia",
  "country.iran": "Irã",
  "country.spain": "Espanha",
  "country.italy": "Itália",
  "country.kazakhstan": "Cazaquistão",
  "country.colombia": "Colômbia",
  "country.malaysia": "Malásia",
  "country.mexico": "México",
  "country.nigeria": "Nigéria",
  "country.pakistan": "Paquistão",
  "country.russia": "Rússia",
  "country.usa": "Estados Unidos",
  "country.turkey": "Turquia",
  "country.uzbekistan": "Uzbequistão",
  "country.ukraine": "Ucrânia",
  "country.philippines": "Filipinas",
  "countrySelection.chooseCountry": "Escolha um país",
  "countrySelection.openAria": "Escolher país",
  "languageSelection.chooseLanguage": "Escolha um idioma",
  "commercial.direction.autotrade": "Auto Mercado",
  "commercial.direction.insurance": "Seguro",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Assistência na estrada",
  "commercial.searchLabel": "Pesquisa BeepApp",
  "commercial.cityPlaceholder": "Digite a cidade",
  "commercial.emptyTitle": "Sem ofertas hoje",
  "commercial.emptyLine1": "Ainda não há parceiros BeepApp ativos na sua cidade",
  "commercial.emptyLine2": "Já estamos trabalhando para encontrá-los e conectá-los",
  "commercial.emptyLine3": "Novas ofertas aparecerão aqui automaticamente",
  "commercial.helperLine1": "Informe sua cidade para ver",
  "commercial.helperLine2": "as ofertas disponíveis",
  "commercial.partnerPrompt": "Quer se tornar parceiro do BeepApp?",
  "commercial.apply": "Enviar solicitação",
  "main.admin": "Admin",
  "main.garage": "Garagem",
  "main.signalSent": "Sinal enviado",
  "main.partnerInviteUnavailable": "Convite de parceiro indisponível",
  "main.enterPlate": "Digite a placa",
  "main.searchError": "Erro de pesquisa",
  "main.signalSendError": "Falha ao enviar o sinal",
  "main.shareCardPrefix": "Cartão da placa",
  "main.shareLinkError": "Não foi possível preparar o link",
  "main.searchByPlateAria": "Pesquisar pela placa",
  "main.russianPlateAria": "Placa russa",
  "main.plateAria": "Placa",
  "main.findPlateAria": "Encontrar placa",
  "main.loadingVehicle": "Carregando cartão da placa…",
  "main.leaveSignal": "Enviar sinal",
  "main.share": "Compartilhar",
  "signalSelection.chooseType": "Escolha o tipo de sinal",
  "signalSelection.category.attention": "Pessoais",
  "signalSelection.category.road": "Trânsito",
  "signalSelection.category.urgent": "Urgentes",
  "signalSelection.chooseSignal": "Escolha um sinal",
  "signalSelection.suggestOwn": "Sugerir outra opção",
  "signalConfirmation.title": "Confirmar sinal",
  "signalConfirmation.plateHeading": "Confira a placa do veículo",
  "signalConfirmation.signalHeading": "Confira o sinal selecionado",
  "signalConfirmation.replyTitle": "Permitir resposta no Telegram",
  "signalConfirmation.replyBody": "Ative esta função para que o proprietário da placa possa\nfalar com você no Telegram. A resposta só é possível se\nvocê tiver um @username. A decisão de responder fica\ncom o proprietário da placa.",
  "signalConfirmation.consentText": "Confirmo que este sinal corresponde\na uma situação real e não é spam\nnem uma denúncia falsa.",
  "signalConfirmation.warning": "Depois do envio, o sinal\nnão poderá ser alterado",
  "signalConfirmation.sending": "Enviando…",
  "signalConfirmation.send": "Enviar",
  "partner.loadingAria": "Carregando",
  "partner.title": "Programa de parceiros",
  "partner.offerLine1": "Receba 30% de todos os pagamentos sem prazo",
  "partner.offerLine2": "feitos pelos usuários convidados ao BeepApp",
  "partner.offerLine3": "pelo programa de afiliados do Telegram",
  "partner.connectUnavailable": "A conexão ficará disponível após a configuração do programa de afiliados do Telegram.",
  "partner.connectTelegram": "Conectar no Telegram",
  "partner.qrAria": "QR code do link de parceiro",
  "partner.download": "Baixar",
  "partner.promoHeading": "Crie um código promocional pessoal",
  "partner.promoHelperLine1": "O código promocional ativa um ano extra de assinatura",
  "partner.promoHelperLine2": "e ajuda a atrair usuários",
  "partner.promoAria": "Código promocional",
  "partner.affiliateHeading": "Seu link de afiliado",
  "partner.affiliateHelper": "Salve o link para criar um QR code pessoal",
  "partner.affiliateAria": "Link de afiliado",
  "partner.qrNoteLine1": "O QR code pode ser colocado no veículo,",
  "partner.qrNoteLine2": "nas redes sociais e em materiais publicitários",
  "partner.save": "Salvar",
  "partner.reset": "Redefinir",
  "partner.resetConfirm": "Redefinir o link de afiliado salvo? O código promocional continuará sendo seu.",
  "partner.promoFormatError": "O código promocional deve ter de 4 a 15 caracteres.",
  "partner.affiliateHostError": "Somente links t.me ou telegram.me são permitidos.",
  "partner.affiliatePathError": "O link não contém um caminho do Telegram.",
  "partner.affiliateFormatError": "Link de afiliado inválido.",
  "partner.loadError": "Erro ao carregar",
  "partner.checkInputError": "Verifique os dados informados",
  "garageActivation.promoInvalid": "Código promocional inválido",
  "garageActivation.plateOccupied": "Esta placa já está vinculada",
  "garageActivation.activateError": "Não foi possível ativar a Garagem",
  "garageEntry.loadJournalError": "Não foi possível carregar o diário",
  "garageEntry.loadStatusesError": "Não foi possível carregar os status",
  "garageEntry.activationSuccess": "Garagem ativada com sucesso",
  "garageEntry.plateAttached": "Placa vinculada",
  "garageEntry.attachError": "Não foi possível vincular a placa",
  "garageEntry.activationNote": "Ative sua Garagem",
  "garageSheet.activationTitle": "Ativação da Garagem",
  "garageSheet.plateHelper": "Digite a placa do veículo",
  "garageSheet.promoHelper": "Você tem um código promocional?",
  "garageSheet.cleanBonusLine1": "Após a ativação, você terá 1 hora",
  "garageSheet.cleanBonusLine2": "para um “Início Limpo” gratuito",
  "garageSheet.activationFor": "Ativação por",
  "garageSheet.cost": "Custo",
  "garageSheet.ownerConsentLine1": "Confirmo que sou o proprietário",
  "garageSheet.ownerConsentLine2": "do veículo com a placa",
  "garageSheet.ownerConsentLine3": "informada.",
  "garageSheet.processing": "Processando...",
  "garageSheet.attach": "Vincular",
  "garageSheet.pay": "Pagar",
  "garageLifecycle.cleanTitle": "Início Limpo",
  "garageLifecycle.deactivateTitle": "Desativação da Garagem",
  "garageLifecycle.cleanWarningLine1": "O histórico da placa será excluído",
  "garageLifecycle.cleanWarningLine2": "sem possibilidade de recuperação!",
  "garageLifecycle.deactivateWarningLine1": "Após a desativação, o acesso aos recursos",
  "garageLifecycle.deactivateWarningLine2": "da Garagem ativa será encerrado",
  "garageLifecycle.willBeDeleted": "SERÁ EXCLUÍDO",
  "garageLifecycle.cleanRemovedLine1": "• Todas as entradas do Diário de Bordo",
  "garageLifecycle.cleanRemovedLine2": "• Histórico de sinais recebidos",
  "garageLifecycle.cleanRemovedLine3": "• Contadores públicos de sinais",
  "garageLifecycle.cleanRemovedLine4": "  no cartão da placa",
  "garageLifecycle.willRemain": "SERÁ MANTIDO",
  "garageLifecycle.cleanPreservedLine1": "• Vínculo da placa à Garagem",
  "garageLifecycle.cleanPreservedLine2": "• Período de ativação restante",
  "garageLifecycle.cleanPreservedLine3": "• Status da placa selecionado",
  "garageLifecycle.cleanPreservedLine4": "• Total de visualizações do cartão da placa",
  "garageLifecycle.freeFirstHour": "Grátis na primeira hora",
  "garageLifecycle.willBecomeUnavailable": "FICARÁ INDISPONÍVEL",
  "garageLifecycle.deactivateRemovedLine1": "• Diário de Bordo",
  "garageLifecycle.deactivateRemovedLine2": "• Seleção e uso do status da placa",
  "garageLifecycle.deactivateRemovedLine3": "• Você sairá automaticamente do AutoClã",
  "garageLifecycle.deactivateRemovedLine4": "• Auto Mercado",
  "garageLifecycle.deactivateRemovedLine5": "• Seguro",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Assistência na estrada",
  "garageLifecycle.deactivateRemovedLine8": "• A placa será desvinculada da Garagem",
  "garageLifecycle.willRemainAvailable": "CONTINUARÁ DISPONÍVEL",
  "garageLifecycle.deactivatePreservedLine1": "• Companheiro",
  "garageLifecycle.deactivatePreservedLine2": "• Despachante",
  "garageLifecycle.deactivatePreservedLine3": "• Pesquisa por placa e visualização",
  "garageLifecycle.deactivatePreservedLine4": "  do cartão público do veículo",
  "garageLifecycle.deactivatePreservedLine5": "• Possibilidade de reativar",
  "garageLifecycle.deactivatePreservedLine6": "  a Garagem a qualquer momento",
  "garageLifecycle.cleanConsentLine1": "Confirmo que concordo com a exclusão",
  "garageLifecycle.cleanConsentLine2": "de todo o histórico desta placa",
  "garageLifecycle.cleanConsentLine3": "sem possibilidade de recuperação.",
  "garageLifecycle.deactivateConsentLine1": "Confirmo a desativação e",
  "garageLifecycle.deactivateConsentLine2": "o encerramento do acesso a todos",
  "garageLifecycle.deactivateConsentLine3": "os recursos da Garagem ativa.",
  "garageLifecycle.clean": "Limpar",
  "garageLifecycle.deactivate": "Desativar",
} satisfies Record<MessageKey, string>
